import React, { useEffect } from 'react'; 
import Footer from '../common/Footer';



export default function AppPrivacy(prop) {
    let lang = prop.lang ? prop.lang : "kr";
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    
    return ( 
        <>
            <div id="container" >
                <div id="contents" className="contact">
                    <div className="page_title-section">
                        <div className="section-inner">
                            <div className="center-box">
                                <p className="page_title">
                                {lang === "ko" ? (
                                    <span>개인정보 보호정책</span>
                                ) : (
                                    <span>Privacy Policy</span>
                                )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <section className="section full-section privacy_wrap">
                        <div className="section-inner">
                            <div className="center-box">
                                <div className="content-panel">
                                    <div className="panel-header ">
                                    {lang === "ko" ? (
                                        <p className="tit point_circle white_circle">
                                        개인정보 보호정책
                                        </p>
                                    ) : (
                                        <p className="tit point_circle white_circle">
                                        Privacy Policy
                                        </p>
                                    )}
                                    </div>
                                    <div className="panel-body">
                                        {lang === "ko" ? (
                                        <div className="privacy-contents">
                                            <p>
                                            [MOPIC](이하 "회사")은 이용자의 개인정보를 중요하게 생각하며, 「개인정보 보호법」 등 관련 법령을 준수합니다. 회사는 이용자의 개인정보를 다음과 같이 수집·이용·보관·파기합니다.
                                            </p>
                                            <ol>
                                                <li>
                                                    <h4>1. 수집하는 개인정보 항목</h4>
                                                    <p>회사는 서비스 제공 과정에서 다음과 같은 정보가 자동으로 수집될 수 있습니다.</p>
                                                    <ul className="circle">
                                                        <li><p>서비스 이용 기록: IP 주소, 쿠키, 접속 로그, 기기 정보(OS, 단말기 모델명, 브라우저/앱 버전 등)</p></li>
                                                        <li><p>기기 캘리브레이션 정보: 렌즈 보정 값, 입체 영상 맞춤을 위한 시청 환경 데이터</p></li>
                                                    </ul>
                                                    <p>※ 회원가입 절차가 없으므로, 이름·이메일·휴대전화번호 등 직접 입력 정보는 수집하지 않습니다.</p>
                                                </li>
                                                <li>
                                                    <h4>2. 수집하는 않는 개인정보 항목</h4>
                                                    <p>회사는 아래와 같은 개인정보는 일체 수집·저장하지 않습니다.</p>
                                                    <ul className="circle">
                                                        <li><p>사용자의 얼굴 이미지, 생체 정보 등 카메라를 통해 식별 가능한 개인정보</p></li>
                                                        <li><p>카메라 촬영 영상 자체</p></li>
                                                        <li><p>AI 학습 및 분석을 위한 영상·이미지 데이터</p></li>
                                                    </ul>
                                                    <p>※ 카메라는 오직 실시간 렌더링 및 입체 영상 보정과 같은 기능 수행을 위해서만 사용됩니다.</p>
                                                </li>
                                                <li>
                                                    <h4>3. 개인정보의 수집 및 이용 목적</h4>
                                                    <p>회사는 수집한 개인정보를 다음의 목적으로만 이용합니다.</p>
                                                    <ul className="circle">
                                                        <li><p>서비스 최적화 및 오류 해결</p></li>
                                                        <li><p>사용자 맞춤형 입체 영상 제공(렌즈 캘리브레이션 반영)</p></li>
                                                        <li><p>서비스 보안, 부정 이용 방지</p></li>
                                                        <li><p>통계 분석 및 서비스 개선</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>4. 개인정보의 보유 및 이용 기간</h4>
                                                    <ul className="circle">
                                                        <li><p>서비스 이용 과정에서 자동으로 생성되는 로그 기록은 「통신비밀보호법」에 따라 최소 3개월간 보관하며, 이후 지체 없이 파기합니다.</p></li>
                                                        <li><p>그 외의 개인정보는 이용 목적 달성 시 즉시 파기합니다.</p></li>
                                                        <li><p>단, 다른 법령에 따라 일정 기간 보관이 필요한 경우 해당 법령에서 정한 기간 동안 보관합니다.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>5. 개인정보 제3자 제공 및 위탁</h4>
                                                    <ul className="circle">
                                                        <li><p>회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.</p></li>
                                                        <li><p>다만, 법령에 따라 필요한 경우 또는 이용자의 사전 동의를 받은 경우에 한해 제공될 수 있습니다.</p></li>
                                                        <li><p>개인정보 처리 위탁이 필요한 경우, 위탁받는 자와 업무 내용은 공지 후 동의를 받습니다.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>6. 개인정보의 파기 절차 및 방법</h4>
                                                    <ul className="circle">
                                                        <li><p>전자적 파일 형태로 저장된 개인정보는 복구할 수 없는 방법으로 삭제합니다.</p></li>
                                                        <li><p>서비스 제공 과정에서 생성된 캘리브레이션 데이터는 앱 삭제 시 함께 파기됩니다.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>7. 이용자의 권리 및 행사 방법</h4>
                                                    <ul className="circle">
                                                        <li><p>이용자는 자신의 개인정보 열람, 정정, 삭제, 처리정지 요구를 회사에 요청할 수 있습니다.</p></li>
                                                        <li><p>앱 내 설정 메뉴 또는 고객센터를 통해 언제든 권리 행사가 가능합니다.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>8. 개인정보 보호를 위한 안전조치</h4>
                                                    <p>회사는 개인정보 보호를 위해 다음과 같은 조치를 취합니다.</p>
                                                    <ul className="circle">
                                                        <li><p>데이터 암호화 및 접근 권한 제한</p></li>
                                                        <li><p>보안 프로그램 설치 및 정기 점검</p></li>
                                                        <li><p>개인정보 취급 직원의 최소화 및 교육 실시</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>9. 개인정보 보호책임자</h4>
                                                    <ul className="circle">
                                                        <li><p>성명: 신창봉</p></li>
                                                        <li><p>Email: cb.shin@mopiclabs.com</p></li>
                                                        <li><p>연락처: 031-8084-9866</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>10. 고지의 의무</h4>
                                                    <ul className="circle">
                                                        <li><p>본 개인정보 처리방침은 2025년 9월 11일부터 적용됩니다.</p></li>
                                                        <li><p>내용 추가, 삭제 및 수정이 있을 경우 앱 내 공지사항을 통해 사전 고지합니다.</p></li>
                                                    </ul>
                                                </li>
                                            </ol>
                                        </div>
                                        ) : (
                                        <div className="privacy-contents">
                                            <p>
                                                [MOPIC] (“the Company”) values your personal information and complies with applicable privacy laws, including the Personal Information Protection Act of Korea and relevant global regulations. This Privacy Policy explains how we collect, use, retain, and protect your personal data.
                                            </p>
                                            <ol>
                                                <li>
                                                    <h4>1. Personal Information Collected</h4>
                                                    <p>The Company may automatically collect the following information in the course of providing services:</p>
                                                    <ul className="circle">
                                                        <li><p>Service usage records: IP address, cookies, access logs, device information (OS, device model, browser/app version, etc.)</p></li>
                                                        <li><p>Device calibration data: Lens correction values and viewing environment data used for stereoscopic video adjustment</p></li>
                                                    </ul>
                                                    <p>※ Since there is no membership or sign-up process, the Company does not collect directly entered information such as name, email address, or mobile phone number.</p>
                                                </li>
                                                <li>
                                                    <h4>2. Personal Information Not Collected</h4>
                                                    <p>The Company does not collect or store the following types of personal information:</p>
                                                    <ul className="circle">
                                                        <li><p>User facial images, biometric data, or any other personally identifiable information obtained via the camera</p></li>
                                                        <li><p>Camera-captured video content itself</p></li>
                                                        <li><p>Any video or image data for AI training or analysis purposes</p></li>
                                                    </ul>
                                                    <p>※ The camera is used solely for real-time rendering and stereoscopic video calibration functions and is never used for any other purpose.</p>
                                                </li>
                                                <li>
                                                    <h4>3. Purpose of Collection and Use</h4>
                                                    <p>The Company uses collected information only for the following purposes:</p>
                                                    <ul className="circle">
                                                        <li><p>To provide and optimize the service, including error resolution</p></li>
                                                        <li><p>To deliver personalized stereoscopic video content (based on calibration data)</p></li>
                                                        <li><p>To maintain service security and prevent misuse</p></li>
                                                        <li><p>To conduct statistical analysis and improve services</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>4. Retention and Use Period</h4>
                                                    <ul className="circle">
                                                        <li><p>Service usage logs (such as access records) are retained for at least 3 months in accordance with the Communications Secrets Protection Act and will be destroyed without delay thereafter.</p></li>
                                                        <li><p>All other data is immediately deleted once the purpose of use has been fulfilled.</p></li>
                                                        <li>
                                                            <p>Where applicable laws require longer retention, the Company will retain the data for the period specified by such laws.</p>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>5. Provision and Entrustment of Personal Data</h4>
                                                    <ul className="circle">
                                                        <li><p>The Company does not disclose users’ personal information to third parties without consent.</p></li>
                                                        <li><p>Information may only be provided when required by law or when prior consent has been obtained.</p></li>
                                                        <li><p>If personal data processing is outsourced, we will notify users of the recipient and purpose and manage the processor appropriately.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>6. Destruction of Personal Data</h4>
                                                    <ul className="circle">
                                                        <li><p>Personal information in electronic files is permanently deleted using methods that prevent recovery.</p></li>
                                                        <li><p>Calibration data generated during service use will be deleted along with the app uninstallation or service termination.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>7. User Rights</h4>
                                                    <ul className="circle">
                                                        <li><p>Users may request access, correction, deletion, or suspension of their personal data at any time.</p></li>
                                                        <li><p>Such requests can be made via the in-app settings or by contacting our customer support.</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>8. Safeguards for Personal Information</h4>
                                                    <p>We take the following measures to protect personal information:</p>
                                                    <ul className="circle">
                                                        <li><p>Encryption and restricted access to data</p></li>
                                                        <li><p>Installation and regular updates of security programs</p></li>
                                                        <li><p>Limiting access to personal data to authorized personnel only and providing training</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>9. Data Protection Officer</h4>
                                                    <ul className="circle">
                                                        <li><p>Name: Shin Changbong</p></li>
                                                        <li><p>Email: cb.shin@mopiclabs.com</p></li>
                                                        <li><p>Phone: +82-31-8084-9866</p></li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <h4>10. Changes to this Privacy Policy</h4>
                                                    <ul className="circle">
                                                        <li><p>This Privacy Policy is effective as of 2025-09-11.</p></li>
                                                        <li><p>Any revisions, additions, or deletions will be notified in advance through in-app announcements or our website.</p></li>
                                                    </ul>
                                                </li>
                                            </ol>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer lang={lang} className="mt0"></Footer>
        </>
    )
}